module.exports = __webpack_public_path__ + "static/media/l_dot_5.a3b73453.png";